import { useEffect } from 'react';
import './App.css';
import Layout from './components/layout';
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
function App() {
  useEffect(() => {
    AOS.init({
      once: true,
      // useClassNames: true,
      // initClassName: false,
      // animatedClassName: 'animated',
      duration: 1000,
    });
  }, []);
  return <Layout />;
}

export default App;
